import type React from 'react';
import { useTenderDetails } from '../../contexts/TenderDetailsContext';
import QuickSettings from './QuickSettings';
import WorkflowStep from './WorkflowStep';

const ConfigurationStep: React.FC = () => {
  const {
    canManageTender,
    openStep,
    setOpenStep,
    stepCompletion,
    toggleStepCompletion,
    quickSettings,
    handleQuickSettingsChange,
    selectedTemplates,
    handleTemplateChange,
    availableTemplates,
    account,
    handleClientLanguageChange,
    handleSaveAsDefault,
    setIsSavingDefault,
    isSavingDefault,
    tender,
    sectionsCount,
  } = useTenderDetails();

  if (!canManageTender) {
    return null;
  }

  return (
    <WorkflowStep
      stepNumber={6}
      expanded={openStep === 6}
      onChange={(_, isExpanded) => setOpenStep(isExpanded ? 6 : null)}
      title="Configuration"
      description="Tune the AI parameters and configure outputs."
      isComplete={!!stepCompletion[6]}
      onToggleComplete={() => toggleStepCompletion(6)}
      optional={true}
    >
      <QuickSettings
        quickSettings={quickSettings}
        onQuickSettingsChange={handleQuickSettingsChange}
        selectedTemplates={selectedTemplates}
        onTemplateChange={handleTemplateChange}
        availableTemplates={availableTemplates}
        clientLanguage={account?.clientLanguage}
        onClientLanguageChange={handleClientLanguageChange}
        onSaveAsDefault={() => handleSaveAsDefault(quickSettings, setIsSavingDefault)}
        isSavingAsDefault={isSavingDefault}
        hasDraftGenerated={
          !!tender?.draftFileLink ||
          tender?.draftResponse?.status === 'Sections Generated' ||
          tender?.draftResponse?.status?.toLowerCase() === 'complete' ||
          sectionsCount > 0
        }
      />
    </WorkflowStep>
  );
};

export default ConfigurationStep;
